<app-sidebar></app-sidebar>


<div style="ba2ckground-color:rgb(244, 244, 244);height:100%; " class="container">



    <div style="height:30px"></div>
    <div *ngIf="impersonationId" style="position:absolute;top:0;right:0;padding:5px 10px;color:white;background-color:rgb(228, 6, 6);z-index:99;">
        Impersonating user ID: {{ impersonationId }}
    </div>


    <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="p-4">
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perspiciatis distinctio nisi laborum consectetur
            itaque provident veritatis quaerat quibusdam amet. Iste obcaecati unde ducimus veniam incidunt qui, sunt
            doloremque non pariatur.
        </div>
        <div class="p-4">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Mollitia placeat tempora autem architecto odit
            eligendi consectetur facere ea voluptates distinctio accusamus quas explicabo voluptatem sint, nisi,
            praesentium aspernatur enim! Dolor?
            <button class="px-4 py-2 font-bold text-white bg-blue-200 rounded hover:bg-blue-700">
                Mein Button
            </button>
            <button class="px-4 py-2 font-bold text-white bg-blue-500 rounded hover:bg-blue-700">
                Mein Button
            </button>
            <button class="px-4 py-2 font-bold text-white bg-blue-600 rounded hover:bg-blue-700">
                Mein Button
            </button>
            <button class="px-4 py-2 font-bold text-white bg-blue-700 rounded hover:bg-blue-700">
                Mein Button
            </button>
            <button class="px-4 py-2 font-bold text-white bg-blue-800 rounded hover:bg-blue-700">
                Mein Button
            </button>
        </div>
    </div> -->


    <!-- <h1 class="text-3xl font-bold mb-2">Dashboard</h1> -->
    <div class="flex justify-around" style="display: flex; justify-content: space-around; flex-wrap: nowrap;">
        <div (click)="projects ? newproject() : null" class="dashbox m-4 bg-white shad2ow-lg rounded-lg p-5 transition duration-200 ease-in-out transform hover:-translate-y-1 hover:scale-110"
            style="flex: 1 1 30%; max-width: 400px;;cursor:pointer;border-radius: 20px !important;    border: 1px solid #9f22c2;">
            <h2 class="text-2xl font-bold mb-3 text-center">New Project</h2>

            <div class="text-gray-700 d-flex justify-content-center align-items-center">
                <div class="col-2md-3 dashi2con">
                    <img src="assets/icon-newproject.png" style="height:60px; @media (min-width: 768px) { height: 100px; }" />
                    <!-- <h5 style="margin-top:15px;">New Project</h5> -->
                </div>
            </div>
        </div>
        <div (click)="openExamplesDialog()" class="dashbox  m-4 bg-white sha2dow-lg rounded-lg p-5 transition duration-200 ease-in-out transform hover:-translate-y-1 hover:scale-110"
            style="flex: 1 1 30%; max-width: 400px;;cursor:pointer;border-radius: 20px !important;    border: 1px solid #9f22c2;">
            <h2 class="text-2xl font-bold mb-3 text-center">Examples</h2>

            <div class="text-gray-700 d-flex justify-content-center align-items-center">
                <div class="col-m2d-3 dashico2n">
                    <img src="assets/icon-example.png" style="height:60px; @media (min-width: 768px) { height: 100px; }" />
                    <!-- <h5 style="margin-top:15px;">Examples</h5> -->
                </div>
            </div>
        </div>
        <div (click)="openTutorials()" class="dashbox  m-4 bg-white sha2dow-lg rounded-lg p-5 transition duration-200 ease-in-out transform hover:-translate-y-1 hover:scale-110"
            style="flex: 1 1 30%; max-width: 400px;;cursor:pointer;border-radius: 20px !important;    border: 1px solid #9f22c2;">
            <h2 class="text-2xl font-bold mb-3 text-center">Tutorials</h2>
            <div class="text-gray-700 d-flex justify-content-center align-items-center">
                <div class="col2-md-3 dashi2con">
                    <img src="assets/icon-tutorials.png" style="height:60px; @media (min-width: 768px) { height: 100px; }" />
                    <!-- <h5 style="margin-top:15px;">Tutorials</h5> -->
                </div>
            </div>
        </div>
    </div>

    <!-- Add floating button for parallel AI -->
    <button *ngIf="isLocalhost" mat-fab color="primary" (click)="openParallelAIDialog()" style="position: fixed; bottom: 20px; right: 20px; z-index: 1000; transform: scale(0.8);" matTooltip="Run Parallel AI">
        <i class="fas fa-robot"></i>
    </button>


    <!-- <div style="position:absolute; top:10px; right:10px; padding:5px 10px;"><i class="fa far fa-user-circle" (click)="showaccountmenu=true"></i>Account
    </div> -->



    <!-- <div class="row" style="background:white; padding: 16px 26px;">
        <div class="col-md-12">
            <h2>Dashboard</h2>
        </div>
    </div> -->


    <!-- <div class="row" style="padding: 6px 36px;background:rgb(229, 229, 229);">
        <div class="col-md-12">
            <h4 style="padding-top:40px; padding-bottom:0px;">Start</h4>
        </div>
    </div> -->


    <div style="right:0px;top:0px; padding:5px 10px;cursor:pointer;position:absolute;z-index:99;cursor:pointer;" (click)="showaccountmenu=!showaccountmenu;$event.stopPropagation()   ">
        <i class="fa-solid fa-circle-user"></i>&nbsp;Account
        <div id="accountmenu" [hidden]="!showaccountmenu" style="position:absolute;z-index:999;background-color:white;padding:2px 2px;right:0px;">
            <div class="contextmenuitem" [routerLink]="'/settings'"><i class="fa fa-window"></i> Settings
            </div>
            <!-- <div class="contextmenuitem" [routerLink]="'invoices'"><i class="fa fa-door"></i> Invoices
                            </div> -->
            <div class="contextmenuitem" (click)="logout()"><i class="fa fa-door"></i> Logout</div>

        </div>
    </div>

    <div class="account-button-container" (click)="showaccountmenu=!showaccountmenu;$event.stopPropagation()">
        <div class="account-button">
            <i class="fa-solid fa-circle-user account-icon"></i>
            <span class="account-text">Account</span>
            <i class="fa-solid fa-chevron-down dropdown-arrow" [class.rotated]="showaccountmenu"></i>
        </div>
        <div class="account-dropdown" [class.show]="showaccountmenu">
            <div class="dropdown-item" [routerLink]="'/settings'">
                <i class="fa fa-cog"></i>
                <span>Settings</span>
            </div>
            <div class="dropdown-item" (click)="logout()">
                <i class="fa fa-sign-out-alt"></i>
                <span>Logout</span>
            </div>
        </div>
    </div>





    <!-- <div class="row" style="padding-left:68px;background:rgb(229, 229, 229);margin-bottom:20px;padding-bottom:20px;">
        <div class="col-md-3 dashicon" (click)="newproject()">
            <img src="assets/icon-newproject.png" style="height:100px" />
            <h5 style="margin-top:15px;">New Project</h5>
        </div>
        <div class="col-md-3 dashicon" (click)="openExamples()">
            <img src="assets/icon-example.png" style="height:100px" />
            <h5 style="margin-top:15px;">Examples</h5>
        </div>
        <div class="col-md-3 dashicon" (click)="openTutorials()">
            <img src="assets/icon-tutorials.png" style="height:100px" />
            <h5 style="margin-top:15px;">Tutorials</h5>
        </div>
    </div> -->

    <div style="height:10px"></div>

    <div class="flex justify-center my-4">
        <input class="sha2dow appearance-none border rounded w-1/2 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" [(ngModel)]="query" (ngModelChange)="searchProjects($event)" id="search"
            type="text" placeholder="Search" style="padding-right: 30px;">
        <!-- <i class="fa fa-search" style="position: absolute; right: 20px; top: 15px;"></i> -->
        <style>
            #search:focus {
                border-color: blue;
            }
        </style>
    </div>

    <div style="height:10px"></div>



    <div class="row" id="contprojects" style="padding: 6px; padding-left: 96px; padding-right: 96px;">
        <style>
            @media (min-width: 768px) {
                #contprojects {
                    padding-left: 196px;
                    padding-right: 196px;
                }
            }

            ::-webkit-scrollbar {
                width: 12px;
            }

            ::-webkit-scrollbar-track {
                background: #f1f1f1 !important;
            }

            ::-webkit-scrollbar-thumb {
                background: #e3e3e3 !important;
            }

            ::-webkit-scrollbar-thumb:hover {
                background: #a8a8a8 !important;
            }

            .filerow:hover .show-on-hover {
                visibility: visible !important;
            }

            .filerow .thumbnail-container {
                position: relative;
                width: 50px;
                height: 40px;
                margin-right: 10px;
                float: left;
                overflow: hidden;
            }

            .filerow .thumbnail-container img {
                position: absolute;
                height: 40px;
                width: 50px;
                object-fit: cover;
                transform: scale(1.2);
                z-index: 1;
            }

            .filerow:hover .thumbnail-container {
                overflow: visible;
            }

            .filerow:hover .thumbnail-container img {
                height: 55px;
                width: 70px;
                transform: scale(1.8) !important;
                transition: all 0.2s ease-in-out;
                z-index: 10;
            }

            .filerow img {
                transition: all 0.2s ease-in-out;
            }

            .grid-view-item {
                border: 1px solid #e0e0e0;
                border-radius: 8px;
                padding: 16px;
                padding-bottom: 40px;
                margin: 8px;
                text-align: center;
                cursor: pointer;
                transition: all 0.2s ease-in-out;
                width: 220px;
                height: 250px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                box-sizing: border-box;
                position: relative;
            }

            .grid-view-item .menu-button {
                position: absolute;
                bottom: 4px;
                right: 4px;
                color: #757575;
            }

            .grid-view-item:hover .menu-button {
                color: #333;
            }

            .grid-view-item img {
                width: 100%;
                height: 150px;
                object-fit: cover;
                object-position: center;
                margin-bottom: 10px;
                border-radius: 4px;
            }

            .grid-view-item .project-name {
                font-weight: bold;
                font-size: 1em;
                margin-bottom: 5px;
                word-wrap: break-word;
                line-height: 1.2;
                max-height: 2.4em;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
            }

            .grid-view-item .project-date {
                position: absolute;
                bottom: 32px;
                right: 5px;
                background-color: rgba(0, 0, 0, 0.75);
                color: white;
                padding: 3px 6px;
                border-radius: 4px;
                font-size: 0.75em;
                opacity: 0;
                visibility: hidden;
                transform: translateY(5px);
                transition: opacity 0.2s ease-in-out, visibility 0.2s step-end 0.2s, transform 0.2s ease-in-out;
                z-index: 10;
            }

            .grid-view-item:hover .project-date {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
                transition-delay: 0s, 0s, 0s;
            }

            .grid-view-item .configurations-link {
                background-color: #e8e0f3;
                color: #5e35b1;
                padding: 3px 6px;
                border-radius: 5px;
                font-size: 11px;
                text-decoration: none;
                display: inline-block;
                margin-top: 8px;
            }

            .grid-view-container {
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                padding: 6px 6px;
                height: 50vh;
                margin-right: 10px;
                overflow: overlay;
                overflow-x: hidden;
            }

            .published-grid-item {
                background-color: #f9f9f9;
                border: 1px solid #e8e8e8;
            }

            .published-grid-item:hover {
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
            }

            .published-projects-bottom-panel {
                position: fixed;
                bottom: 0;
                left: 96px;
                right: 96px;
                width: auto;
                background-color: #ffffff;
                border-top: 1px solid #dddddd;
                box-shadow: 0 -3px 15px rgba(0, 0, 0, 0.15);
                transform: translateY(100%);
                transition: transform 0.4s ease-in-out;
                z-index: 1050;
                padding: 0;
                height: 0;
                max-height: 70vh;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
            }

            @media (min-width: 768px) {
                .published-projects-bottom-panel {
                    left: 196px;
                    right: 196px;
                }
            }

            .published-projects-bottom-panel.open {
                transform: translateY(0);
                height: 70vh;
            }

            .published-projects-bottom-panel .panel-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 15px 20px;
                border-bottom: 1px solid #eee;
                background-color: #fff;
            }

            .published-projects-bottom-panel .panel-header h4 {
                margin: 0;
                font-size: 1.25rem;
            }

            .published-projects-bottom-panel .panel-content {
                overflow-y: auto;
                flex-grow: 1;
                padding: 10px 20px;
            }

            .view-toggle-controls {
                margin-top: 20px;
                margin-bottom: 20px;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .view-toggle-controls button {
                margin-left: 8px;
                margin-right: 8px;
            }

            /* Account Button Styles */
            .account-button-container {
                position: absolute;
                top: 20px;
                right: 20px;
                z-index: 99;
                cursor: pointer;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            }

            .account-button {
                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                color: white;
                padding: 12px 20px;
                border-radius: 25px;
                display: flex;
                align-items: center;
                gap: 8px;
                box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                transition: all 0.3s ease;
                border: 2px solid transparent;
                min-width: 120px;
                position: relative;
            }

            .account-button:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
                background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
            }

            .account-icon {
                font-size: 18px;
                color: white;
            }

            .account-text {
                font-weight: 600;
                font-size: 14px;
                letter-spacing: 0.5px;
            }

            .dropdown-arrow {
                font-size: 12px;
                margin-left: auto;
                transition: transform 0.3s ease;
            }

            .dropdown-arrow.rotated {
                transform: rotate(180deg);
            }

            .account-dropdown {
                position: absolute;
                top: 100%;
                right: 0;
                background: white;
                border-radius: 12px;
                box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
                border: 1px solid #e0e0e0;
                min-width: 160px;
                opacity: 0;
                visibility: hidden;
                transform: translateY(-10px);
                transition: all 0.3s ease;
                margin-top: 8px;
                overflow: hidden;
            }

            .account-dropdown.show {
                opacity: 1;
                visibility: visible;
                transform: translateY(0);
            }

            .dropdown-item {
                padding: 12px 16px;
                display: flex;
                align-items: center;
                gap: 10px;
                color: #333;
                text-decoration: none;
                transition: all 0.2s ease;
                cursor: pointer;
                border-bottom: 1px solid #f0f0f0;
            }

            .dropdown-item:last-child {
                border-bottom: none;
            }

            .dropdown-item:hover {
                background: linear-gradient(135deg, #f8f9ff 0%, #f0f2ff 100%);
                color: #667eea;
            }

            .dropdown-item i {
                font-size: 14px;
                width: 16px;
                text-align: center;
                color: #757575;
            }

            .dropdown-item:hover i {
                color: #667eea;
            }

            .dropdown-item span {
                font-size: 14px;
                font-weight: 500;
            }

            /* Responsive adjustments */
            @media (max-width: 768px) {
                .account-button-container {
                    top: 15px;
                    right: 15px;
                }

                .account-button {
                    padding: 10px 16px;
                    min-width: 100px;
                }

                .account-text {
                    font-size: 13px;
                }
            }

            /* Hide the old account button */
            div[style*="right:0px;top:0px"] {
                display: none !important;
            }

            #accountmenu {
                display: none !important;
            }
        </style>


        <div class="col-md-12">
            <h4 class="font-bold text-gray-800" style="font-size:22px">Projects</h4>
            <!-- List View Container -->
            <div *ngIf="!showGridView" style="padding: 6px 6px;    height:50vh; margin-right:10px;     overflow: overlay; overflow-x:hidden;">

                <!-- Loading spinner for current projects -->
                <div *ngIf="!projects" class="flex justify-center items-center h-full">
                    <img src="/assets/loading-m.png">
                </div>

                <!-- Empty state for current projects -->
                <div *ngIf="projects && projects.length === 0" class="flex flex-col justify-center items-center h-full text-center">
                    <img src="assets/icon-newproject.png" style="height: 60px; opacity: 0.5; margin-bottom: 16px;">
                    <p class="text-gray-500">No projects yet. Click "New Project" above to get started!</p>
                </div>

                <div class="row filerow" *ngFor="let p of filteredProjects" (click)="navigateTo(p.route, $event)" (auxclick)="navigateTo(p.route, $event)"
                    style="margin-left:0px; margin-right:10px;border-bottom:1px solid rgb(236, 236, 236)">
                    <div class="col-md-10">
                        <div style=" vertical-align:middle ;">
                            <!-- <i class="fa fa-file"></i>  -->
                            <div class="thumbnail-container">
                                <img [src]="p.image" style="margin-right:10px;float:left;" />
                            </div>
                            <div style="width:calc(100% - 80px);float:left;">
                                <span class="text-gray-800" style="line-height:26px;font-weight:bold">{{p.name}}</span>

                                <br>
                                <span class="text-gray-400" style="line-heig2ht:14px;font-size:12px">{{p.lastsave |
                                    date:'short'}}</span>
                            </div>
                        </div>

                    </div>

                    <div class="col-md-2">
                        <!--          <button style="float:right;" (click)="$event.stopPropagation()" mat-button
                            [matMenuTriggerFor]="menu"> <i class="fa fas fa-caret-down fa1-2x text-gray-800"></i>
                        </button> -->

                        <button style="float:right; visibility: hidden;" class="show-on-hover text-gray-800" (click)="$event.stopPropagation()" mat-button [matMenuTriggerFor]="menu"> <i
                                class="fa fas  fa-bars fa1-2x"></i> </button>

                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="deleteproject(p);$event.stopPropagation()">Delete</button>
                            <button mat-menu-item (click)="renameproject(p);$event.stopPropagation()">Rename</button>
                            <!-- <button mat-menu-item (click)="cloneproject(p);$event.stopPropagation()">Duplicate</button> -->
                            <!-- <button mat-menu-item (click)="publishproject(p);$event.stopPropagation()">Publish...</button> -->
                        </mat-menu>

                    </div>

                </div>
            </div>
            <!-- Grid View Container -->
            <div *ngIf="showGridView" class="grid-view-container">
                <!-- Loading spinner for current projects -->
                <div *ngIf="!projects" class="flex justify-center items-center h-full w-full">
                    <img src="/assets/loading-m.png">
                </div>

                <!-- Empty state for current projects -->
                <div *ngIf="projects && projects.length === 0" class="flex flex-col justify-center items-center h-full w-full text-center">
                    <img src="assets/icon-newproject.png" style="height: 60px; opacity: 0.5; margin-bottom: 16px;">
                    <p class="text-gray-500">No projects yet. Click "New Project" above to get started!</p>
                </div>

                <div class="grid-view-item" *ngFor="let p of filteredProjects" (click)="navigateTo(p.route, $event)" (auxclick)="navigateTo(p.route, $event)">
                    <img [src]="p.image ? p.image : 'assets/icon-newproject.png'" [alt]="p.name" onerror="this.src='assets/icon-newproject.png'" />
                    <div>
                        <span class="project-name">{{p.name}}</span>
                        <br>
                        <span class="project-date">{{p.lastsave | date:'short'}}</span>
                    </div>
                    <button mat-icon-button class="menu-button" (click)="$event.stopPropagation()" [matMenuTriggerFor]="projectGridMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #projectGridMenu="matMenu">
                        <button mat-menu-item (click)="deleteproject(p);$event.stopPropagation()">Delete</button>
                        <button mat-menu-item (click)="renameproject(p);$event.stopPropagation()">Rename</button>
                    </mat-menu>
                </div>
            </div>
        </div>

        <div class="col-md-12 text-center my-4 view-toggle-controls">
            <button mat-icon-button (click)="toggleView()" title="Toggle List/Grid View">
                <mat-icon>{{ showGridView ? 'view_list' : 'view_module' }}</mat-icon>
            </button>
            <button mat-stroked-button color="primary" (click)="togglePublishedPanel()">
                {{ showPublishedPanel ? 'Hide' : 'View' }} Published Projects
            </button>
        </div>

    </div>

    <!-- New Bottom Panel for Published Projects -->
    <div class="published-projects-bottom-panel" [class.open]="showPublishedPanel">
        <div class="panel-header">
            <h4>Published Projects</h4>
            <button mat-icon-button (click)="togglePublishedPanel()" title="Close Panel">
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <div class="panel-content">
            <!-- List View for Published Projects (inside panel) -->
            <div *ngIf="!showGridView" style="padding: 6px 6px; height:auto; overflow: overlay; overflow-x:hidden;">
                <!-- Loading spinner for published projects -->
                <div *ngIf="!publishedprojects" class="flex justify-center items-center h-full">
                    <img src="/assets/loading-m.png">
                </div>

                <!-- Empty state for published projects -->
                <div *ngIf="publishedprojects && publishedprojects.length === 0" class="flex flex-col justify-center items-center h-full text-center">
                    <img src="assets/icon-example.png" style="height: 60px; opacity: 0.5; margin-bottom: 16px;">
                    <p class="text-gray-500">No published projects yet. Create a project and publish it to see it here!
                    </p>
                </div>

                <div class="row filerow" *ngFor="let p of filteredPublishedProjects" [routerLink]="['/configurations', p.id]" style="margin-left:0px; margin-right:10px;border-bottom:1px solid rgb(236, 236, 236)">

                    <div class="col-md-10">
                        <div style=" vertical-align:middle ;">
                            <div class="thumbnail-container">
                                <img [src]="p.image ? p.image : 'assets/icon-example.png'" onerror="this.src='assets/icon-example.png'" style="margin-right:10px;float:left;" />
                            </div>

                            <span class="text-gray-800" style="line-height:26px;font-weight:bold">
                                {{p.name}}
                                <i class="fa fa- fa-window"></i>
                                <i class="fa fa- fa-window"></i>
                            </span>

                            <a *ngIf="p.configscount" class="bg-blue-600" [routerLink]="['/configurations', p.id]" (click)="$event.stopPropagation()"
                                style="background-color:rgb(179, 137, 255); color:white; padding:2px 5px; border-radius:5px;font-size:12px; text-decoration:none;">
                                {{p.configscount}} configurations</a>

                            <br>
                            <span class="text-gray-400" style="line-heig2ht:14px;font-size:12px">{{p.publishtime |
                                date:'short'}} - {{p.lastConfigTime | date:'short'}}</span>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <button style="float:right; visibility: hidden;" class="show-on-hover text-gray-800" (click)="$event.stopPropagation()" mat-button [matMenuTriggerFor]="pubMenuInPanel"> <i
                                class="fa fas  fa-bars fa1-2x"></i> </button>
                        <mat-menu #pubMenuInPanel="matMenu">
                            <button mat-menu-item (click)="deletepublicproject(p);$event.stopPropagation()">Delete</button>
                            <button mat-menu-item (click)="goToLink('/p/'+p.id);$event.stopPropagation()">Open</button>
                        </mat-menu>
                    </div>
                </div>
                <style>
                    .filerow:hover .show-on-hover {
                        visibility: visible !important;
                    }
                </style>
            </div>

            <!-- Grid View for Published Projects (inside panel) -->
            <div *ngIf="showGridView" class="grid-view-container" style="height:auto;">
                <!-- Loading spinner for published projects -->
                <div *ngIf="!publishedprojects" class="flex justify-center items-center h-full w-full">
                    <img src="/assets/loading-m.png">
                </div>

                <!-- Empty state for published projects -->
                <div *ngIf="publishedprojects && publishedprojects.length === 0" class="flex flex-col justify-center items-center h-full w-full text-center">
                    <img src="assets/icon-example.png" style="height: 60px; opacity: 0.5; margin-bottom: 16px;">
                    <p class="text-gray-500">No published projects yet. Create a project and publish it to see it here!
                    </p>
                </div>

                <div class="grid-view-item published-grid-item" *ngFor="let p of filteredPublishedProjects" [routerLink]="['/configurations', p.id]">
                    <img [src]="p.image ? p.image : 'assets/icon-example.png'" [alt]="p.name" onerror="this.src='assets/icon-example.png'" />
                    <div>
                        <span class="project-name">
                            {{p.name}}
                        </span>
                        <a *ngIf="p.configscount" class="configurations-link" [routerLink]="['/configurations', p.id]" (click)="$event.stopPropagation()">
                            {{p.configscount}} configurations
                        </a>
                    </div>
                    <div>
                        <span class="project-date">{{p.publishtime | date:'short'}} - {{p.lastConfigTime |
                            date:'short'}}</span>
                    </div>
                    <button mat-icon-button class="menu-button" (click)="$event.stopPropagation()" [matMenuTriggerFor]="publishedGridMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #publishedGridMenu="matMenu">
                        <button mat-menu-item (click)="deletepublicproject(p);$event.stopPropagation()">Delete</button>
                        <button mat-menu-item (click)="goToLink('/p/'+p.id);$event.stopPropagation()">Open</button>
                    </mat-menu>
                </div>
            </div>
        </div>
    </div>

</div>




<!-- loading animation -->
<div [hidden]="!loading" style="position:absolute;top:0;left:0;z-index:999;width:100%;height:100%;background:rgba(0, 0, 0, 0.265);">
    <div style="position:fixed;top:50%;left:50%;transform:translate(-50%, -50%);z-index:999;">
        <img src="/assets/loading-m.png" style="">
    </div>
</div>